export function safeExportFileName(name: string, ext: string): string {
  const base = name.replace(/[^a-zA-Z0-9._-]+/g, "_").replace(/^_+|_+$/g, "") || "dashboard";
  return `${base}.${ext}`;
}
